import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJLocalStore from "../../../store/FJLocalStore";
import FJButtonSemicircle from "../../../common/component/button-semicircle/FJButtonSemicircle";
import {FJExportVideoAction, FJSaveAction} from "../../../redux/action/FJRoot.action";
import FJEventConstant from "../../../constant/FJEventConstant";
import FJSaveStore from "../../../store/FJSaveStore";
import FJUtil from "../../../util/FJUtil";
import FJExportIcon from '../../../icon/export-arrow.svg';

class FJExportButtonContainer extends Component {

  componentDidMount() {
    let {CHANGE_SAVE_STATUS} = FJEventConstant;
    let {SAVING} = FJSaveStore.SAVE_STATUS;
    this.changeStatusUnsubscribtion = window.FJEvent.subscribe(CHANGE_SAVE_STATUS, (status) => {
      if (status === SAVING) {
        if (FJUtil.isAnonymousProject()) {
          this.props.setAnonymousStatusAction(true);
        }
      } else {
        this.props.setAnonymousStatusAction(false);
      }
    });
  }

  componentWillUnmount() {
    this.changeStatusUnsubscribtion();
  }

  render() {
    let {className, isAnonymousSaving, duration, disabledClass, textClass, iconClass, userExportVideo} = this.props;

    return (
      <FJButtonSemicircle text={FJLocalStore._('export')}
                          loading={isAnonymousSaving}
                          onClick={userExportVideo}
                          disabled={duration === 0}
                          disabledClass={disabledClass}
                          className={className}
                          type='animation'
                          rightIcon={FJExportIcon}
													textClass={textClass}
													iconClass={iconClass}

      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAnonymousSaving: state.save.isAnonymousSaving,
    duration: state.timeline.duration,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    userExportVideo: function () {
      dispatch(FJExportVideoAction.userExportVideoAction());
      dispatch(FJExportVideoAction.getResolutionByLevelAction());
    },
    setAnonymousStatusAction: function (value) {
      dispatch(FJSaveAction.setAnonymousStatusAction(value));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJExportButtonContainer);
